import { SetErrorMessageType } from "@/app/providers/ReactContextProvider/types";
import { fetchProfile } from "@/entities/profile/api/requests";
import { ProfileProps } from "@/entities/profile/types";

interface Props {
  token: string;
  setErrorMessage: SetErrorMessageType;
}

export const profileFetcher = async ({ token, setErrorMessage }: Props) => {
  const response = await fetchProfile({ token, setErrorMessage });

  const profile: ProfileProps | undefined = (
    (await response?.json()) as { data: ProfileProps }
  )?.data;

  if (profile?.reject) {
    localStorage.setItem("rejectExpires", profile.reject.expires_at);
    window.location.replace("/rejected");
  }

  return profile;
};
